import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";

const CustomMultiSelect = ({
  label,
  options,
  selectedValues,
  onChange,
  name,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (value) => {
    let newValues;
    if (selectedValues.includes(value)) {
      newValues = selectedValues.filter((v) => v !== value);
    } else {
      newValues = [...selectedValues, value];
    }
    // Simulate event object for parent handler
    onChange({ target: { name, value: newValues } });
  };

  const handleSelectAll = (e) => {
    e.stopPropagation();
    const allValues = options.map((opt) => opt.value);
    onChange({ target: { name, value: allValues } });
  };

  const handleClearAll = (e) => {
    e.stopPropagation();
    onChange({ target: { name, value: [] } });
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Helper to get labels for selected values
  const getSelectedLabels = () => {
    if (selectedValues.length === 0) return "";

    if (selectedValues.length === 1) {
      const value = selectedValues[0];
      const option = options.find((opt) => opt.value === value);
      return option ? option.label : value;
    }

    return `${selectedValues.length} Selected`;
  };

  return (
    <div
      className="custom-select-container"
      ref={containerRef}
      style={{ position: "relative" }}
    >
      <div className="custom-select-trigger" onClick={toggleDropdown}>
        {selectedValues && selectedValues.length > 0 ? (
          <span
            className="selected-text"
            style={{ color: "#333", fontWeight: 500 }}
          >
            {getSelectedLabels()}
          </span>
        ) : (
          <span className="placeholder-text" style={{ color: "#9ca3af" }}>
            {label}
          </span>
        )}
        <FiChevronDown
          className={`arrow ${isOpen ? "open" : ""}`}
          style={{
            transition: "transform 0.2s",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </div>
      {isOpen && (
        <div
          className="custom-options-list"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: "white",
            border: "1px solid #e2e8f0; border-color: var(--border-primary)",
            borderRadius: "6px",
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            marginTop: "4px",
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          <div
            className="actions-row"
            style={{
              padding: "8px 12px",
              borderBottom: "1px solid #e2e8f0",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "0.85rem",
              fontWeight: 500,
            }}
          >
            <span
              onClick={handleSelectAll}
              style={{
                color: "#6366f1",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              Select All
            </span>
            <span
              onClick={handleClearAll}
              style={{
                color: "#ef4444",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              Clear All
            </span>
          </div>
          {options.length > 0 ? (
            options.map((option) => (
              <div
                key={option.value}
                className="custom-option"
                onClick={() => handleOptionClick(option.value)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px 12px",
                  cursor: "pointer",
                  backgroundColor: selectedValues.includes(option.value)
                    ? "#f1f5f9"
                    : "white",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (!selectedValues.includes(option.value))
                    e.currentTarget.style.backgroundColor = "#f8fafc";
                }}
                onMouseLeave={(e) => {
                  if (!selectedValues.includes(option.value))
                    e.currentTarget.style.backgroundColor = "white";
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedValues.includes(option.value)}
                  readOnly
                  style={{
                    width: "16px",
                    height: "16px",
                    accentColor: "#6366f1",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: "0.9rem", color: "#475569" }}>
                  {option.label}
                </span>
              </div>
            ))
          ) : (
            <div
              style={{
                padding: "12px",
                color: "#94a3b8",
                textAlign: "center",
                fontSize: "0.9rem",
              }}
            >
              No items available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomMultiSelect;
